export const initialRoleState = {
  role: null,
  user: {
    id: null,
    name: null,
    email: null,
    phone_number: null,
    profile_picture: null,
  },
};

export const roleReducer = (state, action) => {
  switch (action.type) {
    case "SET_ROLE":
      return {
        ...state,
        role: action.payload.role,
        user: {
          id: action.payload.id,
          name: action.payload.name,
          email: action.payload.email,
          phone_number: action.payload.phone_number,
          profile_picture: action.payload.profile_picture,
        },
      };
    case "CLEAR_ROLE":
      return initialRoleState;
    default:
      return state;
  }
};
